module.exports = __webpack_public_path__ + "img/complete-activate.10b0736c.png";